import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children, 
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center font-heading font-bold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rutabaga-wood disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-rutabaga-wood text-white hover:bg-rutabaga-woodDark shadow-md hover:shadow-lg border border-transparent",
    secondary: "bg-rutabaga-green text-white hover:bg-opacity-90 shadow-md hover:shadow-lg border border-transparent",
    outline: "bg-transparent border-2 border-rutabaga-text text-rutabaga-text hover:bg-rutabaga-text hover:text-white",
    ghost: "bg-transparent text-rutabaga-text hover:bg-rutabaga-pink/20",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-6 py-2.5 text-base",
    lg: "px-8 py-3.5 text-lg",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};